<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    lines?: number;
    minWidth?: number;
    maxWidth?: number;
    fullWidth?: boolean;
  }>(),
  {
    lines: 5,
    minWidth: 300,
    maxWidth: 500,
    fullWidth: false,
  },
);

function randomWidthStyle() {
  const range = props.maxWidth - props.minWidth;
  const px = Math.round(Math.random() * range) + props.minWidth;
  return `width: ${px}px`;
}

function widthStyles() {
  if (props.fullWidth) {
    return "width: 100%";
  } else {
    return randomWidthStyle();
  }
}
</script>

<template>
  <div>
    <div
      v-for="t of lines"
      :key="t"
    >
      <span
        class="placeholder"
        :style="widthStyles()"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
